import { useState, useEffect } from 'react';

/**
 * A custom hook that debounces a value after a specified number of milliseconds.
 *
 * @param value - The input value to be debounced.
 * @param milliSeconds - The amount of time in milliseconds to debounce the value.
 * @returns {string} - The debounced value.
 */
export const useDebounce = (value: string, milliSeconds: number) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, milliSeconds);

    return () => {
      clearTimeout(handler);
    };
  }, [value, milliSeconds]);

  return debouncedValue;
};
